import { HelpTooltip } from '../../components/HelpTooltip';
import { useEditorStore } from '../../store/editorStore';
import type { RepairSpot } from '../editState';

function newSpot(kind: RepairSpot['kind']): RepairSpot {
  return {
    id: crypto.randomUUID(),
    kind,
    x: 0.5,
    y: 0.5,
    radius: 0.05,
    sourceX: 0.4,
    sourceY: 0.4,
    opacity: 1,
  };
}

// Healing / clone spot list. Placement on-canvas + pixel blending is the next
// enhancement; this manages the repair entries and their type/help.
export function RepairPanel() {
  const repairs = useEditorStore((s) => s.state.repairs);
  const update = useEditorStore((s) => s.update);

  return (
    <>
      <div className="rowbtns">
        <button
          className="chip"
          onClick={() => update((d) => d.repairs.push(newSpot('heal')))}
        >
          + Heal <HelpTooltip id="heal" />
        </button>
        <button
          className="chip"
          onClick={() => update((d) => d.repairs.push(newSpot('clone')))}
        >
          + Clone <HelpTooltip id="clone" />
        </button>
      </div>

      <p className="stub-note">
        Spot placement and pixel blending run on-canvas — coming next. Added
        spots are saved with the edit so they persist.
      </p>

      {repairs.length === 0 && <p className="hint">No repair spots.</p>}
      {repairs.map((r, i) => (
        <div key={r.id} className="masklist">
          <span className="masklist__name">
            {r.kind === 'heal' ? 'Healing' : 'Clone'} spot {i + 1}
          </span>
          <button
            className="masklist__x"
            aria-label="Delete spot"
            onClick={() =>
              update((d) => {
                d.repairs = d.repairs.filter((x) => x.id !== r.id);
              })
            }
          >
            ×
          </button>
        </div>
      ))}
    </>
  );
}
